async function getPrefectures(param) {
  const queryParams = new URLSearchParams(param);

  return fetch(`/api/prefectures/list-of-region?${queryParams}`
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

async function countFromPrefecture(param, api) {
  const queryParams = new URLSearchParams(param);
  return fetch(`${api}?${queryParams}`
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

async function getListPrefectureByIds(param) {
  const queryParams = new URLSearchParams(param);
  return fetch(`/api/prefectures/list-prefecture-by-ids?${queryParams}`
  ).then(res => {
    return res;
  })
  .catch(errors => {
    return errors;
  })
}

export { getPrefectures, countFromPrefecture, getListPrefectureByIds }
